import { contractorPerformanceTestHistoryStatusOptions } from "constants/SelectFieldOptions"
import { UITypes } from "types"

import { StatusOfPerformanceTest } from "components/table/columnComponents/StatusOfPerformanceTest"
import { TempChangeOfPerformanceTest } from "components/table/columnComponents/TempChangeOfPerformanceTest"

export const customerDashboardPerformanceTestTableHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "Test Date",
    name: "result_date",
    size: "middle",
    type: "sort",
  },
  {
    title: "Status",
    type: "select",
    name: "status",
    size: "small",
    options: contractorPerformanceTestHistoryStatusOptions,
    cellComponent: StatusOfPerformanceTest,
  },
  {
    title: "Label",
    type: "sort-search",
    name: "label",
    size: "small",
  },
  {
    title: "Temp change",
    type: "default",
    name: "temp_change",
    size: "middle",
    cellComponent: TempChangeOfPerformanceTest,
  },
]
